import { useState, useEffect, useRef } from 'react';
import Dropdown from './Dropdown';
import { trackCategoryClick } from 'utils/helper/custom';
import { Link } from 'react-router-dom';

const MenuItems = ({ items, depthLevel, handlehamburger, handleCategoryClick, urlPath }) => {
  const [dropdown, setDropdown] = useState(false);
  let ref = useRef();

  useEffect(() => {
    const handler = (event) => {
      if (
        dropdown &&
        ref.current &&
        !ref.current.contains(event.target)
      ) {
        setDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [dropdown]);

  const onMouseEnter = () => {
    window.innerWidth > 960 && setDropdown(true);
  };

  const onMouseLeave = () => {
    window.innerWidth > 960 && setDropdown(false);
  };

  const closeDropdown = (item, categoryName = "") => {
    if (window.innerWidth < 961) {
      handlehamburger();
      dropdown && setDropdown(false);
    }
    if (categoryName) {
      trackCategoryClick({ category_name: categoryName });
    }
    if (item && item.url && handleCategoryClick) {
      const urlParts = item.url.split('/').filter(Boolean);
      const id = urlParts[urlParts.length - 1];
      const slug = urlParts[urlParts.length - 2];
      
      handleCategoryClick(item.url);
    }
  };
  if (urlPath) {
      items.url = urlPath;
  }

  return (
    <li
      className="menu-items"
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    // onClick={closeDropdown}
    >
      {items.url && items.submenu ? (
        <>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? 'true' : 'false'}
            onClick={() => setDropdown((prev) => !prev)}
          >
            {window.innerWidth < 960 && depthLevel === 0 ? (
              items.title
            ) : (              
              <Link to={items.url} onClick={(e) => {
                e.preventDefault();
                closeDropdown(items, items.title)
              }}>{items.title}</Link>
            )}

            {depthLevel > 0 &&
              window.innerWidth < 5 ? null : depthLevel > 0 &&
                window.innerWidth > 960 ? (
              <img src="/images/arrow_forward.svg" className='arrow-child' />
            ) : (
              <img src="/images/arrow_forward.svg" className='arrow-main'/>
            )}
          </button>
          <Dropdown
            handlehamburger={handlehamburger}
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
            handleCategoryClick={handleCategoryClick}
          />
        </>
      ) : !items.url && items.submenu ? (
        <>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? 'true' : 'false'}
            onClick={() => setDropdown((prev) => !prev)}
          >
            {items.title}{' '}
            {depthLevel > 0 ? (
              <img src="/images/arrow_forward.svg" className='arrow-child'/>
            ) : ( 
              <img src="/images/arrow_forward.svg" className='arrow-main'/>
            )}
          </button>
          <Dropdown
            handlehamburger={handlehamburger}
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
            handleCategoryClick={handleCategoryClick}
          />
        </>
      ) : (
        <Link to={items.url} onClick={(e) => {
          e.preventDefault();
          closeDropdown(items, items.title)
        }}>{items.title}</Link>
      )}
    </li>
  );
};

export default MenuItems;
